export default {
  en: {
    connect: 'Connect',
    connected: {
      full: 'Connected',
      less: '',
    },
    view: 'View',
    failed: 'Request failed',
    cancel: 'Cancel',
    accept: 'Accept',
    reject: 'Reject',
    restricted: 'Temporarily restricted',
    restrictedTooltip:
      "You're unable to send connection requests to other organisations until you have completed your assessment.",
    clientReceive: {
      full: 'This supplier would like to connect with you',
      less: 'Request received.',
    },
    supplierReceive: {
      full: 'This client would like to connect with you',
      less: 'Request received.',
    },
    clientSend: {
      full: 'You requested to be their client.',
      less: 'Request sent.',
    },
    supplierSend: {
      full: 'You requested to be their supplier.',
      less: 'Request sent.',
    },
    verifyMessage:
      'To help {0} verify your connection request, include the name of your account manager or another identifier such as an account number in the message below.',
    contactName: 'Your point of contact name...',
    contactEmail: 'Your point of contact email...',
    messagePlaceholder: 'Your message to {0}...',
    messageAutofillShort:
      'Hi - {senderOrg} would like to connect with you to review your Risk Ledger assessment. Thanks, {senderUser} ({senderEmail})',
    messageAutofillLong:
      'Hi - {senderOrg} would like to connect with you to review your Risk Ledger assessment. We emailed {contact} on [date] letting them know of this request. Thanks, {senderUser} ({senderEmail})',
    contactDetails: '{contactName} ({contactEmail})',
    addDate: 'Please add the date of contact or modify the message.',
    invalidEmail: 'Please enter a valid email address.',
    send: 'Send request',
    sendFailed: 'Failed to send connection request.',
    acceptSuccess: 'Connection request accepted',
    acceptError: 'Failed to accept connection request',
    rejectSuccess: 'Connection request rejected',
    rejectError: 'Failed to reject connection request',
    cancelSuccess: 'Connection request cancelled',
    cancelError: 'Failed to cancel connection request',
    primerEmail: {
      desc: 'I confirm a {primerEmail} has been sent to this supplier.',
      link: 'Primer email',
    },
    cancelModal: {
      title: 'Are you sure you want to cancel the connection request for {0}?',
      cancel: 'Yes, cancel connection request',
      close: 'No',
    },
    missingContactModal: {
      title: 'Missing supplier contact details',
      description:
        "Adding a contact helps suppliers verify who you are and can speed up the connection process. If you don't have a contact, let us know the reason below.",
      reasonLabel: "Reason you don't have supplier contact details",
      placeholder: 'Select reason',
      addDetails: 'Add details',
      connectAnyway: 'Connect anyway',
      reasons: {
        tooEarly: 'Too early in the process',
        noDetails: "Supplier hasn't provided contact details",
        noDetailsClient: "Client hasn't provided contact details",
        viewingSupplier: 'Just viewing this supplier',
        viewingClient: 'Just viewing this client',
        other: 'Other',
      },
    },
    rejectModal: {
      title: 'Are you sure you want to reject the connection request from {orgName}?',
      reject: 'Reject',
      cancel: 'Cancel',
      reasonQuestion: 'Why are you rejecting this connection request?',
      reasonPlaceholder: 'Rejection reason...',
      error: 'Failed rejecting connection request. Please try again.',
    },
  },
};
